interface Props {
  paths: string[];
  className: string;
}

/**
 * Shared renderer for vendored Tabler Icons path data (MIT License,
 * Copyright (c) 2020-2026 Paweł Kuna, https://tabler.io/icons). Path data is
 * copied directly rather than added as an npm dependency; see
 * IngredientGlyph and FoodTypeGlyph for the per-domain literal-match maps.
 */
export function TablerIcon({ paths, className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths.map((d, index) => (
        <path key={index} d={d} />
      ))}
    </svg>
  );
}
